import outdatedBrowserRework from 'outdated-browser-rework';
import './outdated-browser-rework.scss';

// prettier-ignore
const locales = ["aa","ab","ae","af","ak","am","an","ar","as","av","ay","az","ba","be","bg","bh","bi","bm","bn","bo","br","bs","ca","ce","ch","co","cr","cs","cu","cv","cy","da","de","dv","dz","ee","el","en","eo","es","et","eu","fa","ff","fi","fj","fo","fr","fy","ga","gd","gl","gn","gu","gv","ha","he","hi","ho","hr","ht","hu","hy","hz","ia","id","ie","ig","ii","ik","io","is","it","iu","ja","jv","ka","kg","ki","kj","kk","kl","km","kn","ko","kr","ks","ku","kv","kw","ky","la","lb","lg","li","ln","lo","lt","lu","lv","mg","mh","mi","mk","ml","mn","mr","ms","mt","my","na","nb","nd","ne","ng","nl","nn","no","nr","nv","ny","oc","oj","om","or","os","pa","pi","pl","ps","pt","qu","rm","rn","ro","ru","rw","sa","sc","sd","se","sg","si","sk","sl","sm","sn","so","sq","sr","ss","st","su","sv","sw","ta","te","tg","th","ti","tk","tl","tn","to","tr","ts","tt","tw","ty","ug","uk","ur","uz","ve","vi","vo","wa","wo","xh","yi","yo","za","zh","zu"];
const audiMessageEn = `You are using an unsupported browser to access this website. To get the best User-Experience while visiting the website, please use the latest versions of Chrome, Firefox, Safari or Edge.`;
const audiThankYouEn = `Thank you very much for your visit.<br> Your Audi Team`;
const audiMessageDe = `Sie nutzen einen Browser, der für diese Website nicht mehr unterstützt wird. Für die beste User Experience auf dieser Website nutzen Sie bitte die neueste Version von Chrome, Firefox oder Edge.`;
const audiThankYouDe = `Danke für Ihren Besuch und viel Spaß.<br> Ihr Audi Team`;

const defaultMessages = {
  outOfDate: audiMessageEn,
  unsupported: audiMessageEn,
  update: {
    web: audiThankYouEn,
    googlePlay: audiThankYouEn,
    appStore: audiThankYouEn
  },
  url: null,
  callToAction: '',
  close: 'Close'
};
const defaultForAllLocales = {};
locales.forEach((locale) => {
  defaultForAllLocales[locale] = defaultMessages;
});
const messages = {
  ...defaultForAllLocales,
  de: {
    outOfDate: audiMessageDe,
    unsupported: audiMessageDe,
    update: {
      web: audiThankYouDe,
      googlePlay: audiThankYouDe,
      appStore: audiThankYouDe
    },
    url: null,
    callToAction: '',
    close: 'Schließen'
  }
};
outdatedBrowserRework({
  backgroundColor: 'white',
  textColor: '#333',
  fullscreen: false,
  browserSupport: {
    Chrome: 84,
    Edge: 85,
    Safari: 12,
    'Mobile Safari': 12,
    Firefox: 79,
    Opera: false,
    Vivaldi: false,
    Yandex: false,
    IE: false
  },
  requireChromeOnAndroid: false,
  isUnknownBrowserOK: false,
  messages
});
